// extracted by mini-css-extract-plugin
export default {"blueColor":"#4a90e2","form":"_11ZrKAVHqh2Wq9zIiRlolB","submitContainer":"_19rapTCeTmFcP6U2ZmtUcP","error":"_2Nr_EkcsK2K5pJ8jOPjbaK"};